export type DestroyFeed = (feedId: string) => Promise<Record<string, never>>
